<div class="tab-content">
  <div>
    <mojo-candidate-resume-skill
      [keywords]="keywords"
      [skills]="hardSkills"
      groupName="Hard Skills"
    >
    </mojo-candidate-resume-skill>
    <mojo-candidate-resume-skill
      [keywords]="keywords"
      [skills]="softSkills"
      groupName="Soft Skills"
    >
    </mojo-candidate-resume-skill>
  </div>
</div>
